import AffinityStripePaymentState, { initialState } from "@affinity/Store/AffinityStripePaymentState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Category } from "@insite/client-framework/Services/CategoryService";
import placeOrder from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { Draft, isDraft } from "immer";

const reducer = {
    "Affinity/StripePayment/Initialise/Start": (
        draft: Draft<AffinityStripePaymentState>,
        action: {}
    ) => {
        draft.isInitialising = true;
    },
    "Affinity/StripePayment/Initialise/Complete": (
        draft: Draft<AffinityStripePaymentState>,
        action: { stripeKey: string | undefined }
    ) => {
        draft.isInitialising = false;
        draft.isInitialised = true;
        draft.stripeKey = action.stripeKey;
    }
}

export default createTypedReducerWithImmer(initialState, reducer);